import { type DetailedHTMLProps, type ElementType, type ImgHTMLAttributes } from 'react';
import { Link } from '@tanstack/react-router';
import { ImageWrapper } from './ImageWrapper';
import Styles from './logo.module.scss';
import { Flex } from '@radix-ui/themes';

export type LogoProps = {
  component: ElementType<DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>>;
  disableLink?: boolean;
  appearance?: 'light' | 'dark';
  href?: string;
};

const logo = (appearance: 'light' | 'dark') => ({
  src:
    appearance === 'light'
      ? 'https://assets.versori.io/m/logo/versori-logo-wordmark.svg'
      : 'https://assets.versori.io/m/logo/versori-logo-wordmark-white.svg',
  alt: 'Versori Logo',
});
/**
 * Simple component to render out the logo provided in the versoriConfig file.
 */
export function Logo({ disableLink = false, href = '/', appearance = 'light', component }: LogoProps) {
  const { src, alt } = logo(appearance);

  const imageProps = {
    imgSrc: src,
    imgHeight: 'auto',
    imgWidth: 'auto',
    alt,
    component,
  };

  // If linking is disabled just show the image plain
  if (disableLink)
    return (
      <Flex className={Styles.LogoLink} data-disabled={disableLink}>
        <ImageWrapper {...imageProps} />
      </Flex>
    );

  return (
    <Link className={Styles.LogoLink} to={href}>
      <ImageWrapper {...imageProps} />
    </Link>
  );
}
